<div *ngIf="loading"
     class="loading-overlay">
    <i class="fa fa-2x fa-spinner fa-spin text-secondary"></i>
    <h3 class="mt-3 ml-1 text-secondary">Cargando...</h3>
</div>

<div class="row ">

    <div class="col-12">
        <div class="card border rounded animated fadeIn fast">
            <div class="card-body animated fadeIn fast">


                <!-- cabecera -->
                <div class="row mb-2">

                    <div class="col-6">
                        <div class="form-group border border-dark rounded">
                            <input class="form-control"
                                   type="text"
                                   autofocus
                                   placeholder="Buscar cualquier dato..."
                                   (keyup)="buscarTodo($event)" />
                        </div>
                    </div>

                    <div class="col-6">
                        <form>

                            <div class="row float-right">

                                <div class="col-sm-6">
                                    <div class="form-group rounded">
                                        <select class="form-control"
                                                name="rowsLimitStr"
                                                [(ngModel)]="rowsLimitStr"
                                                (change)="rowsLimitChange()">
                                            <option [value]="10">10</option>
                                            <option [value]="50">50</option>
                                            <option [value]="100">100</option>
                                            <option [value]="999999">Todo</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-sm-6">
                                    <div class="form-group float-right">
                                        <div class="btn-group">

                                            <a type="button"
                                               [routerLink]="'/panel/ubi_tipo/new'"
                                               class="btn btn-outline-info btn-circle "
                                               title="Nuevo">
                                                <i class="fa-solid fa-plus"></i>
                                            </a>
                                            <button type="button"
                                                    (click)="cargaLista()"
                                                    class="btn btn-outline-info btn-circle"
                                                    title="Recargar datos">
                                                <i class="fa-solid fa-sync"></i>
                                            </button>
                                            <button type="button"
                                                    (click)="exportToExcel()"
                                                    class="btn btn-outline-info btn-circle"
                                                    title="Descargar Excel">
                                                <i class="fa-solid fa-download"></i>
                                            </button>

                                        </div>
                                    </div>
                                </div>

                            </div>

                        </form>
                    </div>

                </div>




                <div class="rounded border">
                    <!-- datatable -->
                    <ngx-datatable class="bootstrap"
                                   [rows]="rows"
                                   [limit]="rowsLimit"
                                   [loadingIndicator]="loading"
                                   [columnMode]="ColumnMode.flex"
                                   [headerHeight]="50"
                                   [footerHeight]="50"
                                   [summaryRow]="false"
                                   [summaryHeight]="55"
                                   [summaryPosition]="'bottom'"
                                   [rowHeight]="'auto'"
                                   [messages]="messages"
                                   [reorderable]="true">




                        <!-- familia -->
                        <ngx-datatable-column name="Familia"
                                              prop="familia"
                                              [flexGrow]="3"
                                              [minWidth]="120"
                                              [resizeable]="true">
                            <ng-template let-value="value"
                                         ngx-datatable-cell-template>
                                <div>{{value | ubiTipoFamilia}} </div>
                            </ng-template>
                        </ngx-datatable-column>


                        <!-- codigo   -->
                        <ngx-datatable-column name="Código"
                                              prop='codigo'
                                              [flexGrow]="1"
                                              [minWidth]="75">
                            <ng-template let-value="value"
                                         ngx-datatable-cell-template>
                                <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
                            </ng-template>
                        </ngx-datatable-column>


                        <!-- nombre   -->
                        <ngx-datatable-column name="Nombre"
                                              prop='nombre'
                                              [flexGrow]="4"
                                              [minWidth]="180"
                                              [resizeable]="true">
                            <ng-template let-value="value"
                                         ngx-datatable-cell-template>
                                <div [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)"></div>
                            </ng-template>
                        </ngx-datatable-column>



                        <!-- largo   -->
                        <ngx-datatable-column name="Largo máx."
                                              prop='largo'
                                              [flexGrow]="1.5"
                                              [minWidth]="90">
                            <ng-template let-value="value"
                                         ngx-datatable-cell-template>
                                <div class="text-right mr-2">
                                    <span [innerHTML]="funcLib.resaltarTexto(value, textoDestacado) "></span>
                                    <small *ngIf="value"
                                           class="text-muted"> cm</small>
                                </div>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- ancho  -->
                        <ngx-datatable-column name="Ancho máx."
                                              prop="ancho"
                                              [flexGrow]="1.5"
                                              [minWidth]="90">
                            <ng-template let-value="value"
                                         ngx-datatable-cell-template>
                                <div class="text-right mr-2">
                                    <span [innerHTML]="funcLib.resaltarTexto(value, textoDestacado) "></span>
                                    <small *ngIf="value"
                                           class="text-muted"> cm</small>
                                </div>
                            </ng-template>
                        </ngx-datatable-column>


                        <!-- alto -->
                        <ngx-datatable-column name="Alto máx."
                                              prop='alto'
                                              [flexGrow]="1.5"
                                              [minWidth]="90">
                            <ng-template let-value="value"
                                         ngx-datatable-cell-template>
                                <div class="text-right mr-2">
                                    <span [innerHTML]="funcLib.resaltarTexto(value, textoDestacado)  "></span>
                                    <small *ngIf="value"
                                           class="text-muted"> cm</small>
                                </div>
                            </ng-template>
                        </ngx-datatable-column>


                        <!-- peso  -->
                        <ngx-datatable-column name="Peso máx."
                                              prop='peso'
                                              [flexGrow]="1.5"
                                              [minWidth]="90">
                            <ng-template let-value="value"
                                         ngx-datatable-cell-template>
                                <div class="text-right mr-2">
                                    <span [innerHTML]="funcLib.resaltarTexto(value, textoDestacado) "></span>
                                    <small *ngIf="value"
                                           class="text-muted"> kg</small>
                                </div>
                            </ng-template>
                        </ngx-datatable-column>



                        <!-- Acciones -->
                        <ngx-datatable-column name=""
                                              [flexGrow]="1"
                                              [minWidth]="80"
                                              [maxWidth]="110"
                                              [sortable]="false"
                                              [canAutoResize]="false">
                            <ng-template let-row="row"
                                         let-value="value"
                                         ngx-datatable-cell-template>

                                <div ngbDropdown
                                     class="d-inline-block "
                                     container="body">
                                    <button class="btn btn-sm btn-outline-secondary dropdown-toggle"
                                            data-toggle="dropdown"
                                            type="button"
                                            style="border-width: 1px;">
                                        <i class="fa-solid fa-ellipsis-vertical"></i>
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-left">
                                        <a [routerLink]="['/panel/ubi_tipo',row.id]"
                                           class="link mr-2 dropdown-item"
                                           placement="top"
                                           title="Editar tipo de ubicación">
                                            <i class="fa-solid fa-pen-to-square"></i> Editar
                                        </a>

                                        <hr style="margin: 0px;">

                                        <a (click)="deleteRow(row)"
                                           class="link mr-2 pointer dropdown-item text-danger"
                                           placement="top"
                                           data-toggle="tooltip"
                                           title="Borrar tipo de ubicación">
                                            <i class="fa-regular fa-trash-can fa"></i> Borrar
                                        </a>

                                    </div>
                                </div>

                            </ng-template>
                        </ngx-datatable-column>


                    </ngx-datatable>
                </div>

            </div>
        </div>
    </div>

</div>